'use client'

import { T } from '@/components/t'
import { NeotasteExplanationVideo } from '@/features/marketing-videos/neotaste-explanation-video'
import { cn } from '@/utils/styles/cn'

interface IHomeVideoProps {
    withNudge?: boolean
    titleClassName?: string
}

export const HomeVideo = ({ withNudge = true, titleClassName }: IHomeVideoProps) => {
    return (
        <div className="w-full flex pt-4 flex-col items-center justify-center max-w-full">
            <T
                t="home.video.title"
                h2
                className={cn('mb-6 text-[28px] md:text-[40px]', titleClassName)}
            />

            {/* These measurements make sure, that there is no layout shift as the video loads */}
            <NeotasteExplanationVideo className="mb-8" />

            {withNudge && <T t="home.video.nudge" p className="text-center font-semibold" />}
        </div>
    )
}
